import { VerificationLevel } from "@wingspanhq/wingspan-api-sdk";
import { queriesOnboarding } from "@query";
import { useQueryPaymentsStatus } from "../../query/payments/queries";
import { VerificationStatus } from "@wingspanhq/payments/dist/interfaces";

export const useTaxVerificationVersion = () => {
  const queryVerifications = queriesOnboarding.getOnboardingStatus.useQuery(
    undefined,
    { select: status => status.verifications }
  );
  const queryPaymentsSettings = useQueryPaymentsStatus();

  const defaultTaxVerificationStatus = queryVerifications.isFetched
    ? queryVerifications.data?.tax
    : undefined;

  const isLegacyTaxVerification = queryPaymentsSettings.isFetched
    ? queryPaymentsSettings.data?.verifications.taxDocumentation ===
      VerificationStatus.Verified
    : false;

  const isDefaultTaxVerificationNotActive =
    defaultTaxVerificationStatus === undefined ||
    defaultTaxVerificationStatus === VerificationLevel.NONE ||
    defaultTaxVerificationStatus === VerificationLevel.UPDATE_REQUIRED;

  const isLegacyOnlyTaxVerification =
    isDefaultTaxVerificationNotActive && isLegacyTaxVerification;

  return {
    isLoading:
      !queryVerifications.isFetched || !queryPaymentsSettings.isFetched,
    isLegacyTaxVerification,
    isLegacyOnlyTaxVerification
  };
};
